// src/components/ClientPortalTimeExpenses.js

import React from 'react';
import 'animate.css';

function ClientPortalTimeExpenses({ currentUser, clients, timeEntries, expenseEntries, cases }) {
  // Find the specific client profile linked to the current user
  const clientProfile = clients.find(client => client.user === currentUser.id);

  // Filter time entries relevant to this specific client profile or their cases
  const clientTimeEntries = timeEntries.filter(entry =>
    entry.client === (clientProfile ? clientProfile.id : null) ||
    (entry.case && cases.some(c => c.id === entry.case && c.client === (clientProfile ? clientProfile.id : null)))
  );

  // Filter expense entries relevant to this specific client profile or their cases
  const clientExpenseEntries = expenseEntries.filter(entry =>
    entry.client === (clientProfile ? clientProfile.id : null) ||
    (entry.case && cases.some(c => c.id === entry.case && c.client === (clientProfile ? clientProfile.id : null)))
  );

  return (
    <div className="client-portal-time-expenses animate__animated animate__fadeInUp">
      <h2 className="mb-4 text-primary">Your Time & Expenses</h2>
      {clientProfile ? (
        <p className="lead text-secondary">Review time logged and expenses incurred for your cases, {clientProfile.first_name} {clientProfile.last_name}.</p>
      ) : (
        <p className="lead text-warning">Your user account is not yet linked to a client profile. Please contact the firm administrator to view your time and expenses.</p>
      )}

      <h3 className="mt-4 text-secondary">Time Entries</h3>
      {clientTimeEntries.length > 0 ? (
        <div className="table-responsive mb-5">
          <table className="table table-hover table-striped shadow-sm rounded overflow-hidden">
            <thead className="bg-primary text-white">
              <tr>
                <th>Date</th>
                <th>Hours</th>
                <th>Description</th>
                <th>Associated Case</th>
                <th>Logged By</th>
              </tr>
            </thead>
            <tbody>
              {(clientTimeEntries || []).map(entry => (
                <tr key={entry.id}>
                  <td>{entry.date}</td>
                  <td>{entry.hours}</td>
                  <td>{entry.description}</td>
                  <td>{entry.case_title || 'N/A'}</td>
                  <td>{entry.logged_by_username || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-info mt-4" role="alert">
          No time entries found associated with your client profile or cases.
        </div>
      )}

      <h3 className="mt-4 text-secondary">Disbursements</h3>
      {clientExpenseEntries.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover table-striped shadow-sm rounded overflow-hidden">
            <thead className="bg-primary text-white">
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Category</th>
                <th>Description</th>
                <th>Associated Case</th>
                <th>Incurred By</th>
                <th>Receipt</th>
              </tr>
            </thead>
            <tbody>
              {(clientExpenseEntries || []).map(entry => (
                <tr key={entry.id}>
                  <td>{entry.date}</td>
                  <td>P{parseFloat(entry.amount).toFixed(2)}</td>
                  <td>{entry.category}</td>
                  <td>{entry.description}</td>
                  <td>{entry.case_title || 'N/A'}</td>
                  <td>{entry.incurred_by_username || 'N/A'}</td>
                  <td>
                    {entry.receipt ? (
                      <a href={entry.receipt} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary rounded-pill">View Receipt</a>
                    ) : (
                      'N/A'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-info mt-4" role="alert">
          No disbursements found associated with your client profile or cases.
        </div>
      )}
    </div>
  );
}

export default ClientPortalTimeExpenses;
